<template>
    <div class="bg-gray-100">
        <header class="w-full bg-white border-b border-gray-400 fixed top-0 left-0 shadow-md">
            <img class="h-10 sm:h-16" src="../resources/logo-fme.jpg">
        </header>
        <section class="mx-auto mt-10 sm:mt-16 max-w-screen-lg">
            <div v-show="offersCount">
                <a href="#"
                   @click="showOffers = true"
                   class="mt-2 mr-2 shadow-md pt-2 fixed right-0 rounded-full bg-yellow-300 text-red-700 w-10 h-10 text-center align-middle font-semibold">
                {{ offersCount }}
                </a>
            </div>
            <div v-if="showOffers"
                 class="fixed inset-0 mx-2 mt-12 mb-2 bg-white shadow-md rounded-16">
                 <div class="">
                     <a class="fixed right-0 top-0 mt-12 mx-2 p-2 bg-yellow-300 rounded-full" href="#" @click="showOffers = false">
                         <svg class="fill-current text-red-800 h-6 w-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z"/></svg>
                     </a>
                 </div>
                 <ul class="mx-4 my-4">
                 <li v-for="item in items" :key="item.code" v-if="item.offeredAmount">
                     {{ item.name }} : {{ item.offeredAmount }}
                 </li>
                 <button class="font-semibold text-lg rounded-md bg-red-700 text-white w-full px-4 my-2">
                     Enregistrer
                 </button>
                 </ul>
            </div>
            <div class="bg-white text-gray-700">
                <h1 class="p-2 bg-red-700 text-white text-xl font-semibold text-white text-center leading-tight uppercase">
                    Vente sur offre <br>
                    n° 1 - avril 2020 <br>
                    BD &amp; Illustrations
                </h1>
                <div class="px-4 py-6">
                    <img class="float-left rounded-full h-32 w-32 object-center p-3"
                         src="data:image/jpeg;base64,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">
                    <p>
                        Chers amis Bonjour !
                    </p>
                    <p>
                        J'ai le plaisir de vous convier à cette première vente
                        sur offre !
                    </p>
                    <p>
                        En raison du confinement, vous le savez, toutes les maisons
                        de ventes sont fermés.
                    </p>
                    <p>
                        J'ai donc décidé de mettre en place ce système simple qui
                        vous permettra d'acquérir tout type de pièces de collections.
                    </p>
                    <p>
                        Vous recevrez régulièrement des messages de ce type et si
                        une pièce qui est proposé à la vente vous intéresse,
                        il vous suffira alors de cliquer sur le lien "Faire une
                        offre" et de remplir les cases correspondantes.
                    </p>
                    <p>
                        Comme vous êtes tous des clients fidèles et connus de moi,
                        parfois ancien client de Bddirect.com que j'ai dirigé
                        pendant 27 ans, ou client des différentes maisons de ventes
                        aux enchères que j'ai eu comme partenaires, nous pouvons
                        travailler en confiance.
                    </p>
                    <p>
                        Ainsi pas de paiement direct pour pouvoir faire une offre,
                        vous paierez une fois les résultats connus.
                    </p>
                </div>
                <div class="px-4 py-6 bg-yellow-400 text-red-900">
                    <h2 class=" text-xl w-full font-semibold pb-4 px-2">Comment ça marche</h2>
                    <p>
                        Alors comment ca marche une vente sur offre ?
                    </p>
                    <p>
                        contrairement à une vente aux enchères, ou les prix montent
                        au fur et à mesure, vous faites ici l'offre maximum qui vous
                        parait raisonnable.
                    </p>
                    <p>
                        Toutes les offres sont ensuite dépouillées à la date de fin
                        de vente et le gagnant est celui qui a fait l'offre la plus
                        importante.
                    </p>
                    <p>
                        Mais le gagnant ne paye pas le prix maximum qu'il a offert !
                        Il paye la moyenne entre le prix inférieur et son offre.
                        Ainsi si monsieur X fait une offre à 100 et Monsieur Y fait
                        une offre à 200, c'est monsieur Y qui gagne l'enchere mais
                        il payera son lot 150 euros, majoré des frais de vente qui sont
                        de 22%.
                    </p>
                    <p>
                        Pour chaque lot l'estimation basse correspond à peu près au
                        prix de réserve quand il y en a un, et l'estimation haute au
                        prix estimé du lot.
                    </p>
                    <p>
                        Nous sommes au regret de ne pas pouvoir accepter des offres
                        inférieur de plus de 10% de l'estimation basse. Ainsi un lot
                        estimé 100 / 200, nous ne pouvons accepter des offres
                        inférieures à 90 !...
                    </p>
                    <p>Je vous rappelle que les frais de vente ne s'élève qu'à 22% TTC</p>
                    <p>Bonnes enchères à tous !</p>
                    <div class="px-6 pt-3">
                        Francois MEYNIEL<br>
                        Expert BD & Illustrations<br>
                        Tél: 06 07 01 10 11
                    </div>
                </div>
                <div class="px-4 py-6 bg-white">
                    <h2 class=" text-xl w-full font-semibold pb-4 px-2">Vendre des lots</h2>
                    <p>
                        Si vous désirez vendre des lots dans le cadre de ces ventes
                        sur offres, n'hésitez pas à me contacter sur mon
                        <a href="#">email</a> et me proposer ce que vous souhaitez
                        vendre, vous aurez des conditions de vente particulières.
                    </p>
                </div>
            </div>
            <div>
                <div class="bg-gray-100">
                    <div class="p-2 pt-2 mb-2 bg-red-700 text-gray-100">
                        <h2 class="px-3 font-bold leading-tight">VENTE SUR OFFRE N°1 AVRIL 2020</h2>
                        <p class="">date limite d'encheres : le jeudi 30 Avril à 22h00</p>
                    </div>

                    <div class="p-2 pt-2 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                        <offer-item v-for="(item, index) in items" :key="item.code" :item="item" :index="index+1" @update-offer="item.offeredAmount = $event"></offer-item>
                    </div>

                </div>
            </div>
        </section>
        <footer class="p-4">
            <div class="text-xs text-gray-600">
                <p>Copyright &copy; 2020 - François Meyniel Expert</p>
                <p>{{ $t('MADE_BY') }}</p>
            </div>
        </footer>
    </div>
</template>

<script>
    import OfferItem from "../Offer/OfferItem.vue";

    export default {
        name: "Home",
        components: {
            OfferItem
        },
        data() {
            return {
                items: [],
                showOffers: false
            };
        },
        created() {
            this.items = this.findItems();
        },
        computed: {
            offersCount() {
                return this.items.filter(item => item.offeredAmount).length;
            }
        },
        methods: {
            findItems() {
                return [
                    {
                        code: "0001",
                        title: "Disney (Studios)",
                        name: "Picsou et Donald",
                        description: "Illustration originale à la gouache et encre de chine sur carton pour un Picsou magazine, année 70/80",
                        format: "33 x 25 cm",
                        estimatedPrice: "600 / 800 euros",
                        offeredAmount: null
                    },
                    {
                        code: "0002",
                        title: "Uderzo, Albert & Studio",
                        name: "Asterix Maxinet",
                        description: "Cello original à l'encre de chine et gouache pour une publicité du détergent Maxinet dans le milieu des années 80",
                        format: "30 x 40 cm",
                        estimatedPrice: "100 / 200 euros",
                        offeredAmount: null
                    },
                    {
                        code: "0003",
                        title: "Paape,Eddy",
                        name: "Luc Orient",
                        description: "Planche originale à l'encre de chine n°14 issue de l'album \"L'enclume de la foudre\" paru chez Le Lombart en 1993",
                        format: "51 x 36,5 cm",
                        estimatedPrice: "600 / 800 euros",
                        offeredAmount: null
                    },
                    {
                        code: "0004",
                        title: "Hal Campagna",
                        name: "La famille Illico",
                        description: "Illico chez le Dentiste !... Strip à l'encre de chine et trame lettraset, réalisé en 1966<br><br>Signé en bas à droite",
                        format: "14 x 49 cm",
                        estimatedPrice: "80 / 100 euros",
                        videoLink: "https://www.youtube.com/embed/zy_sSR1KJts",
                        offeredAmount: null
                    }
                ]
            }
        }
    }
</script>

<style>
  p {
    @apply px-3 pb-2 leading-snug;
  }
  .btn {
    @apply font-bold py-2 px-4 rounded-lg;
  }
  .btn-red {
    @apply bg-red-700 text-white;
  }
  .btn-red:hover {
    @apply bg-red-600;
  }
  .rounded-16 {
      border-radius: 16px;
  }
</style>